import { createApp } from "vue";
import CustomerReviewsPage from "./customerReviewsPage.vue";
import { createPinia } from "pinia";
createApp(CustomerReviewsPage).use(createPinia()).mount("#customerReviews");
